import { styled } from '@mui/material';

export const StyledNoteMessage = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  maxWidth: '432px',
  width: '100%',
  margin: '1.75rem auto 0',

  '& > svg:first-of-type': {
    marginBottom: '1.5rem',
  },
}));
